export default __webpack_public_path__ + "/dist/images/img-1.cb700da686a8066b5fd8fafca524cdf5.png";